module.exports = __webpack_public_path__ + "factorBreakdown.cf4e6629d76dda14fefd8432371568b9.png";